"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=useFirestore;var _react=require("react"),_ReduxFirestoreContext=_interopRequireDefault(require("./ReduxFirestoreContext"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function useFirestore(){return(0,_react.useContext)(_ReduxFirestoreContext.default)}module.exports=exports.default;
//# sourceMappingURL=useFirestore.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux-firebase/es/useFirestore.js
// module id = 725
// module chunks = 0